<template>
  <div class="action-item-group d-inline-flex align-items-center"
       :class="{ 'action-item-group--buttons': buttons }">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ActionItemGroup',
    compatConfig: {
      MODE: 3,
    },
    props: {
      buttons: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
.action-item-group {
    gap: 3px;

    &--buttons {
      gap: 0.5rem;
    }
}
</style>
